export default {"src":"/_next/static/media/welcome-illustration.700ca475.svg","height":643,"width":857,"blurWidth":0,"blurHeight":0};